import { List, OrderedMap } from "immutable";
import { loadingAsyncState } from "widgets-for-react";
import { fixMediaUrl, processRichText } from "../../Shared/api/drupal/drupalApi";
import { DrupalEmbedToVideo, DrupalMediaToVideo } from "../../Shared/api/drupal/nodeConversionHelpers";
import { getTeasers } from "../../Shared/api/elasticsearch/elasticsearchApi";
import { slugify } from "../../Shared/utils/string";
import { loadFormstackForm } from "../custom_components/components/formstack/formstack_api";
export const richTextBlock = (p)=>({
        kind: "richText",
        title: p.field_title,
        html: p.field_rich_text ? processRichText(p.field_rich_text) : "",
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : "",
        secondaryActionTitle: p.field_secondary_action ? p.field_secondary_action.title : "",
        secondaryActionUrl: p.field_secondary_action ? p.field_secondary_action.url : "",
        media: p.field_inline_media ? {
            media: mediaBlock(p.field_inline_media),
            position: p.field_inline_media.field_position == "text_left" ? "text_left" : "text_right",
            display: p.field_inline_media.field_media_display ?? 'masked'
        } : "none"
    });
export const mediaBlock = (p)=>{
    if (p.field_media.bundle == "video") return {
        kind: "video",
        video: DrupalMediaToVideo(p)
    };
    const urls = p.field_media.field_media_image.image.style_urls;
    const sizes = p.bundle == 'media' ? {
        small: '400w',
        medium: '800w',
        large: '1600w',
        fallback: '800w_fb'
    } : {
        small: '360x300',
        medium: '720x600',
        large: '1080x900',
        fallback: '4x3'
    };
    return {
        kind: "image",
        imageUrlSmall: fixMediaUrl(urls[sizes.small]),
        imageUrl: fixMediaUrl(urls[sizes.medium]),
        imageUrlFallback: fixMediaUrl(urls[sizes.fallback]),
        imageUrlLarge: fixMediaUrl(urls[sizes.large]),
        imageAlt: p.field_media.field_media_image.alt
    };
};
export const faqBlock = (p)=>({
        kind: "faq",
        title: p.field_faq_title,
        entries: p.field_faq_item.reduce((a, e)=>a.set(e.label, e.field_answer ? processRichText(e.field_answer) : ""), OrderedMap())
    });
export const expandersBlock = (p)=>({
        kind: "expanders",
        title: p.field_title,
        entries: p.field_expander_items.reduce((a, e)=>a.set(e.field_title, e.field_rich_text ? processRichText(e.field_rich_text) : ""), OrderedMap())
    });
export const highlightBlock = (p)=>({
        kind: "highlight",
        title: p.field_title,
        subtitle: p.field_subtitle,
        content: p.field_rich_text
    });
export const buttonBlock = (p)=>({
        kind: "knop",
        caption: p.field_link.title,
        href: p.field_link.url
    });
export const imagesBlock = (p)=>({
        kind: "images",
        images: p.field_images.reduce((l, i)=>l.push({
                imageAlt: i.field_media_image.alt,
                imageUrlSmall: fixMediaUrl(i.field_media_image.image.style_urls["400w"]),
                imageUrl: fixMediaUrl(i.field_media_image.image.style_urls["800w"]),
                imageUrlFallback: fixMediaUrl(i.field_media_image.image.style_urls["800w_fb"]),
                imageUrlLarge: fixMediaUrl(i.field_media_image.image.style_urls["1600w"])
            }), List())
    });
export const vacancyOverviewBlock = (p)=>{
    var _p_field_category;
    return {
        kind: "vacancy_overview",
        title: p.field_title,
        html: p.field_rich_text,
        placeholder: p.field_placeholder_text,
        category_id: ((_p_field_category = p.field_category) === null || _p_field_category === void 0 ? void 0 : _p_field_category.id) ?? null
    };
};
export const booksOverviewBlock = (p)=>({
        kind: "books",
        books: p.field_books.map((b)=>{
            var _b_field_image_field_media_image_image, _b_field_image_field_media_image_image1, _b_field_image_field_media_image_image2;
            return {
                title: b.field_title,
                author: b.field_author,
                imageUrl: ((_b_field_image_field_media_image_image = b.field_image.field_media_image.image) === null || _b_field_image_field_media_image_image === void 0 ? void 0 : _b_field_image_field_media_image_image.style_urls) ? fixMediaUrl(b.field_image.field_media_image.image.style_urls["195w"]) : '',
                imageUrlFallback: ((_b_field_image_field_media_image_image1 = b.field_image.field_media_image.image) === null || _b_field_image_field_media_image_image1 === void 0 ? void 0 : _b_field_image_field_media_image_image1.style_urls) ? fixMediaUrl(b.field_image.field_media_image.image.style_urls["400w_fb"]) : '',
                imageUrlLarge: ((_b_field_image_field_media_image_image2 = b.field_image.field_media_image.image) === null || _b_field_image_field_media_image_image2 === void 0 ? void 0 : _b_field_image_field_media_image_image2.style_urls) ? fixMediaUrl(b.field_image.field_media_image.image.style_urls["400w"]) : '',
                imageAlt: b.field_image.field_media_image.alt,
                url: b.field_link.url
            };
        }).toList(),
        title: p.field_title,
        text: p.field_text
    });
export const featuredContentBlock = (p)=>({
        kind: "featured_content",
        title: p.field_title,
        html: p.field_rich_text,
        imageUrl: fixMediaUrl(p.field_image.field_media_image.image.style_urls["470x470"]),
        imageUrlFallback: fixMediaUrl(p.field_image.field_media_image.image.style_urls["1x1"]),
        imageUrlLarge: fixMediaUrl(p.field_image.field_media_image.image.style_urls["940x940"]),
        imageAlt: p.field_image.field_media_image.alt,
        linkTitle: p.field_link.title,
        linkUrl: p.field_link.url
    });
export const activityClusterBlock = (p)=>({
        kind: "activity_cluster",
        title: p.field_title,
        description: p.field_text,
        slug: "",
        activitySummariesIds: p.field_product_db_ids
    });
export const subscriptionsBlock = (p)=>({
        kind: "subscription_block",
        items: p.field_subscription_item.reduce((l, i)=>l.push({
                title: i.field_title,
                price: i.field_price,
                sticker: i.field_sticker ? i.field_sticker : "",
                extra: i.field_text ? i.field_text : "",
                materials: i.field_materials,
                services: i.field_services ? i.field_services : "",
                linkTitle: i.field_link.title,
                linkUrl: i.field_link.url,
                isYouth: i.field_is_youth
            }), List())
    });
export const contentGridBlock = (p)=>({
        kind: "content_grid",
        items: p.field_content_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                subtitle: i.field_subtitle ? i.field_subtitle : "",
                label: i.field_label ? i.field_label : "",
                imageAlt: i.bundle == "content_grid_item" ? i.field_image.field_media_image.alt : "",
                imageUrl: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["400x280"]) : "",
                imageUrlFallback: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["4x3"]) : "",
                imageUrlLarge: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["800x560"]) : "",
                video: i.bundle == "content_grid_video" ? DrupalEmbedToVideo(i.field_video, i.field_title) : undefined,
                linkUrl: i.field_link ? i.field_link.url : ""
            }), List())
    });
export const recentNewsBlock = (p)=>({
        kind: "recent_news",
        title: p.field_title,
        count: p.field_count,
        linkTitle: p.field_link && p.field_link.title,
        linkUrl: p.field_link && p.field_link.url
    });
export const carouselContentGridBlock = (p)=>({
        kind: "carousel_content_grid",
        title: p.field_title,
        items: p.field_content_grid_items.reduce((l, i)=>l.push({
                title: i.field_title,
                subtitle: i.field_subtitle ? i.field_subtitle : "",
                label: i.field_label ? i.field_label : "",
                imageAlt: i.bundle == "content_grid_item" ? i.field_image.field_media_image.alt : "",
                imageUrl: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["400x280"]) : "",
                imageUrlFallback: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["4x3"]) : "",
                imageUrlLarge: i.bundle == "content_grid_item" ? fixMediaUrl(i.field_image.field_media_image.image.style_urls["800x560"]) : "",
                video: i.bundle == "content_grid_video" ? DrupalEmbedToVideo(i.field_video, i.field_title) : undefined,
                linkUrl: i.field_link.url
            }), List()),
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : ""
    });
export const pageGridBlock = (p)=>({
        kind: "async_block",
        promise: ()=>getTeasers(p.field_page_grid_items.map((i)=>i.id.toString()).toArray()),
        block: (teasers)=>({
                kind: "content_grid",
                title: p.field_title,
                items: teasers.map((t)=>({
                        title: t.title,
                        linkUrl: t.url,
                        imageAlt: t.imageAlt,
                        imageUrl: t.imageUrl,
                        imageUrlFallback: t.imageUrlFallback,
                        imageUrlLarge: t.imageUrlLarge,
                        subtitle: t.description
                    })).toList(),
                primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : undefined,
                primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : undefined
            })
    });
export const quoteBlock = (p)=>{
    return {
        kind: "quote",
        quote: p.field_quote_text,
        source: p.field_quote_source && p.field_quote_source != "" ? p.field_quote_source : undefined
    };
};
export const collectionSearchBarBlock = (p)=>{
    return {
        kind: "collection_search_bar"
    };
};
export const gridBlock = (p)=>{
    return {
        kind: "grid_block",
        title: p.field_title,
        row_count: p.field_row_count ? p.field_row_count : 3,
        items: p.field_grid_items.map((i)=>{
            var _i_field_media, _i_field_link;
            const image = (_i_field_media = i.field_media) === null || _i_field_media === void 0 ? void 0 : _i_field_media.field_media_image;
            return {
                title: i.field_title,
                imageAlt: image ? image.alt : "",
                imageUrl: image ? fixMediaUrl(image.image.style_urls['400x280']) : "",
                imageUrlLarge: image ? fixMediaUrl(image.image.style_urls['800x560']) : "",
                imageUrlFallback: image ? fixMediaUrl(image.image.style_urls['4x3']) : "",
                intro: i.field_text,
                linkUrl: (_i_field_link = i.field_link) === null || _i_field_link === void 0 ? void 0 : _i_field_link.url
            };
        }).toList()
    };
};
export const formstackBlock = (p)=>{
    return {
        kind: p.bundle,
        formId: p.field_formstack_form_id,
        state: loadingAsyncState(()=>loadFormstackForm(p.field_formstack_form_id))
    };
};
export const iframeBlock = (p, cookieUpdater)=>({
        kind: 'iframe_block',
        link: p.field_link.url,
        cookieUpdater
    });
export const ctaBlock = (p)=>{
    return {
        kind: "cta_block",
        title: p.field_title,
        description: p.field_description,
        primaryActionTitle: p.field_primary_action ? p.field_primary_action.title : "",
        primaryActionUrl: p.field_primary_action ? p.field_primary_action.url : "",
        secondaryActionTitle: p.field_secondary_action ? p.field_secondary_action.title : "",
        secondaryActionUrl: p.field_secondary_action ? p.field_secondary_action.url : ""
    };
};
export const newsletterSignupBlock = (p)=>{
    return {
        kind: "newsletterForm"
    };
};
export const emptyBlock = (block)=>{
    console.warn("Unable to convert block:", block.bundle);
    return {
        kind: "empty"
    };
};
export const subMenuBlock = (p)=>{
    return {
        kind: "submenu",
        title: p.field_title,
        text: p.field_text,
        links: p.field_items.reduce((l, i)=>l.push({
                title: i.field_link.title,
                url: i.field_link.url.startsWith('#') ? '#' + slugify(i.field_link.url) : i.field_link.url // Leave the URL intact (query params are already decoded from JSON)
            }), List())
    };
};
